'use strict';

/*@ngInject*/
module.exports = function classifiersService($http) {

    this.getObjectCategories = function () {
        return $http.post('classifiers/getObjectCategories/');
    };

    this.getServiceTypes = function () {
        return $http.post('classifiers/getServiceTypes/');
    };

    this.getRoadElementClassifiers = function () {
        return $http.post('classifiers/getRoadElementClassifiers/');
    };

    this.getSuggestionClassifiers = function () {
        return $http.get('classifiers/getSuggestionClassifiers/');
    };

    this.getRouteClassifiers = function () {
        return $http.get('classifiers/getRouteClassifiers/');
    };

    this.getIconsByIconPathAndLanguage = function ($iconsPaths) {
        return $http.post('classifiers/getIconsByIconPathAndLanguage/', $iconsPaths);
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/services/classifiers.service.js
 **/